<template>
    <div class="columns grade-input">
        <div class="column section">
            <div class="card">  
                <div class="card-image">
                    <h2 class="title is-1 card-title">Level 7 <span class="subtitle">Master’s Degree</span></h2>
                    <figure class="image is-4by3">
                        <img loading="lazy" src="@/assets/calculator-card-pictures-7.jpg" alt="">
                    </figure>
                </div>
                <div class="card-content">
                    <div v-for="(item, index) in moreValuesBtnLvMasters" :key="item" class="is-flex is-align-items-center main-row delete-row">
                        <div class="text-area">
                            <div class="rel" v-if="index < 1"><h3>Unit name</h3></div>
                            <input @focus="e => e.target.select()" class="input" type="text" v-model="titleLvMasters[index]" title="Lv 6: Course title input" placeholder="Unit name (optional)">
                        </div>
                        <div class="select">
                            <div class="rel"> <h3 v-if="index < 1">Credits</h3></div>
                            <select  title="Lv 7: Credits number input" @change="handlerLvMastersCreditCounter" v-model="mastersCredits[index]">
                                <option  selected value="0">0</option>
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="15">15</option>
                                <option value="20">20</option>
                                <option value="25">25</option>
                                <option value="30">30</option>
                                <option value="35">35</option>
                                <option value="40">40</option>
                                <option value="45">45</option>
                                <option value="50">50</option>
                                <option value="55">55</option>
                                <option value="60">60</option>
                            </select>
                        </div>
                        <div class="marks">
                            <div class="rel" v-if="index < 1"><h3>Grades</h3></div>
                            <input @change="handlerLvMastersCreditCounter() ; toastNotification(index)" title="Lv 7: Marks number input" @keyup="handlerLvMastersCreditCounter" class="input " min="0" max="100"  @focus="e => e.target.select() " type="number" v-model="mastersMarks[index]" placeholder="0" icon="Group">
                            <div class="toastContainer">
                                <q-btn @click="toast[index] = false" class="toast" v-if="toast[index] === true" no-caps no-wrap color="negative" label="Your mark needs to be a pass" icon="report_gmailerrorred" >
                                </q-btn>
                            </div>
                            <div class="toastContainer">
                                <q-btn @click="toastCompensated[index] = false" class="toast" v-if="toastCompensated[index] === true" no-caps color="negative" label="Compensated pass" icon="report_gmailerrorred" >
                                </q-btn>
                            </div>
                        </div>
                        <div title="Lv 7: Delete rows" @keydown.enter="removeField(index)" @click="removeField(index)">
                            <svg aria-label="Delete row" class="svg-delete" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">
                            <path tabindex="0" d="M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0z M15,11H5V9h10V11z"/></svg>
                        </div>
                    </div>
                </div>
                <div class="submit-btn">
                    <q-btn @click="addMoreValuesHandlerLvMasters" round color="primary" title="Lv 7: Add more rows" icon="add" />
                </div>
                <div v-if="mastersCardCounter" class="credit-total">
                    <div class="credit-total-one" >
                        <p><b>Credits: {{mastersCardCounter}} </b></p>
                        <q-icon v-if="mastersCardCounter == 180"
                        class="ml-3"
                        size="md"
                        color="green"
                        name="check_circle"
                        />
                    </div>
                    <div v-if="mastersCardCounter != 180" class="credit-total-two" >
                        <q-icon class="credit-total-icon" name="info"/>You need exactly 180 Man Met credits
                    </div>
                </div>
            </div>
        </div>
    </div>
        <div class="mt btn-container"><button  title="Click to calculate your grades" class="button is-large mc" @click="$emit('MastersMarksCredits', mastersCreditsCalculated, mastersMarks, mastersCardCounter, mastersPassTotal)"><q-icon left name="calculate"/>Calculate</button></div>
</template>

<script>

import { ref } from 'vue'
import { useQuasar } from 'quasar'
export default {
emits: ["MastersMarksCredits"],
setup(props, {emit}) {

const mastersCredits = ref([0, 0, 0, 0, 0]) 
const mastersPassTotal = ref(0)
let mastersCreditsCalculated = ref([0, 0, 0, 0, 0])
const mastersMarks = ref(['', '', '', '', ''])
const mastersCardCounter = ref(0)
let lvMastersOneTwentyGuide = ref('')
const compensatedMarkmasters = ref(0)
const toast = ref([false, false, false, false, false])
const toastCompensated = ref([false, false, false, false, false])  
const $q = useQuasar()
let moreValuesBtnLvMasters = ref([0, 1, 2, 3, 4])
let titleLvMasters = ref(['', '', '', '', ''])
$q.notify.setDefaults({timeout: 30000, actions: [{ icon: 'close', color: 'white' }]})

const toastNotification = (index) => {
    if(mastersMarks.value[index] >= 40 && mastersMarks.value[index] <= 49 && compensatedMarkmasters.value <= 30 ) {
        $q.notify({
            color: 'negative', message: 'A compensated pass is a unit mark of 40-49%. You can have up to 30 credits of compensated passes a year on most courses, provided your average mark across 120 taught credits at level 7 is over 50%. Some courses have professional requirements that mean a compensated pass isn’t possible. Independent study units and 60 credit units are not eligible for compensation.', icon: 'report_gmailerrorred', position: 'bottom', classes: 'notify', iconSize: '2.5rem'
        })
        toastCompensated.value[index] = true
        setTimeout(() => {
            toastCompensated.value[index] = false
        }, 6000)
    } else if (mastersMarks.value[index] < 50 ) {
        toast.value[index] = true
        setTimeout(() => {
            toast.value[index] = false;
        }, 6000)
    } else {
        toast.value[index] = false
    }
}

const updateCredits = (credits, marks) => {
    emit("updateCredits", credits, marks)
}

const addMoreValuesHandlerLvMasters = () => {
    moreValuesBtnLvMasters.value.push(1)
    titleLvMasters.value.push('')
    mastersCredits.value.push(0)
    mastersMarks.value.push('')
    toast.value.push(false)
    toastCompensated.value.push(false)
}

const removeField = (index) => {
    if( moreValuesBtnLvMasters.value.length != 1) {
    moreValuesBtnLvMasters.value.splice(index, 1);
    titleLvMasters.value.splice(index, 1);
    mastersCredits.value.splice(index, 1);
    mastersMarks.value.splice(index, 1);
    toast.value.splice(index, 1);
    toastCompensated.value.splice(index, 1);
    }

    handlerLvMastersCreditCounter()
}

const handlerLvMastersCreditCounter = () => {
    
    compensatedMarkmasters.value = 0

    mastersPassTotal.value = 0

    ////////////////////////////////////////////
        // "compensatedMarkmasters.value <= 40 && mastersMarks.value[index] >= 40" is the minimum mark before marks go into the componsated marks bucket.
    ///////////////////////////////////////////

    let mastersCreditsCheck = mastersCredits.value.map((i, index) => { 
        if(mastersMarks.value[index] >= 40 && mastersMarks.value[index] <= 49  && i != 60) {
            compensatedMarkmasters.value += Number(mastersCredits.value[index])
        }

        //compensatedMarkmasters.value is counting the credits where the mark is between 40 and 49

        console.log(compensatedMarkmasters.value)

        if(mastersMarks.value[index] >= 50 || compensatedMarkmasters.value <= 30 && mastersMarks.value[index] >= 40 && i <= 30) {
            return i
        } else {
            return i = 0
        }
    }) 

    ///Does each unit have at least 50% mark for pass
    let mastersPass = mastersCredits.value.map((i, index) => { 
         if(mastersMarks.value[index] >= 50 && i > 0) {
             mastersPassTotal.value += Number(mastersCredits.value[index])
        }
    })

    mastersCredits.value.map((i, index) => { 
        if(mastersMarks.value[index] > 100 ) {
            return mastersMarks.value[index] = 100
        } else {
            return
        }
    }) 

    mastersCreditsCalculated.value = mastersCreditsCheck

    let LvMastersCreditsToNum = mastersCreditsCheck.map(i => Number(i))

    mastersCardCounter.value = 0  

    for(let i = 0; i < mastersCredits.value.length; i++) {
        mastersCardCounter.value += LvMastersCreditsToNum[i]
    }

    return { LvMastersCreditsToNum, mastersCreditsCheck, mastersPass}
}

return { 
    moreValuesBtnLvMasters, 
    updateCredits, 
    removeField, 
    titleLvMasters, 
    addMoreValuesHandlerLvMasters, 
    toast, 
    toastNotification, 
    $q, 
    toastCompensated, 
    mastersCredits, 
    mastersCreditsCalculated, 
    mastersMarks, 
    mastersCardCounter, 
    lvMastersOneTwentyGuide, 
    compensatedMarkmasters, 
    handlerLvMastersCreditCounter, 
    mastersPassTotal 
    }
 
}
}
</script>

